import _ from "lodash";
import Backbone from "backbone";

class ModulePageModel extends Backbone.Model {
  toJSON() {
    const attributes = _(this.attributes).clone();
    attributes.presentationTypeToggleUrl = this.urlFor(
      attributes.presentationType,
    );
    attributes.presentationTypeToggleIcon =
      attributes.presentationType === "masonry"
        ? "glyphicon-list"
        : "glyphicon-th";

    return attributes;
  }

  urlFor(presentationType) {
    const internalCode = this.get("internalCode");

    let url;

    if (presentationType === "list") {
      url = `/module/${internalCode}/masonry/`;
    } else if (presentationType === "masonry") {
      url = `/module/${internalCode}/list/`;
    }

    return url;
  }
}

export default ModulePageModel;
